import React from 'react';
import { useState, useEffect } from 'react';
import { getTableNrCookie } from './CookieService';
import './Navigation.css'; // Import the CSS file

const Navigation = ({ title, activeItem }) => {

    const [tableNr, setTableNr] = useState(null);

    useEffect(() => {
        setTableNr(getTableNrCookie());
    }, []);

    return (
        <div>
            <nav className="navbar navbar-dark bg-dark">
                <div className="container-fluid">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span> {title}
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav">
                            <li className={`nav-item ${activeItem === 'bestel' ? 'active' : ''}`}>
                                <a className="nav-link" href={`/table/${tableNr ? tableNr : ""}`}>Bestel</a>
                            </li>
                            <li className={`nav-item ${activeItem === 'mijnBestellingen' ? 'active' : ''}`}>
                                <a className="nav-link" href="/orders/">Mijn bestellingen</a>
                            </li>
                            <li className={`nav-item ${activeItem === 'verander' ? 'active' : ''}`}>
                                <a className="nav-link" href="/" >Verander tafelnr</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};



export default Navigation;